var _circle, _ellipse, _ellipse2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.4813,
    cy: 36.9906,
    r: 36.9906,
    fill: "#F95C04"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.9907,
    cy: 30.4812,
    rx: 3.5,
    ry: 6.5,
    fill: "#4D1F05"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.9907,
    cy: 30.4812,
    rx: 3.5,
    ry: 6.5,
    fill: "#4D1F05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.5283 54.7944L54.2499 54.4126C45.4539 42.3504 27.2009 43.175 19.5283 55.9812V55.9812",
    stroke: "#4C1F05",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad_face.d8933fe1fcae5fb9b90cfec8cade66dc.svg";
export { ForwardRef as ReactComponent };